import * as z from "zod"

export const inventoryItemSchema = z.object({
  category: z.string().min(1, "Please select a category"),
  itemId: z.string().min(1, "Please select an item"),
  itemName: z.string(),
  typeId: z.string().min(1, "Please select a type"),
  typeName: z.string(),
  quantity: z.number().min(1, "Quantity must be at least 1").max(100, "Quantity too large"),
})

export const quoteFormSchema = z.object({
  from: z.string().min(1, "Please select origin city"),
  to: z.string().min(1, "Please select destination city"),
  moveType: z.string().min(1, "Please select move type"),
  name: z.string().min(2, "Name must be at least 2 characters").max(100, "Name is too long"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string()
    .min(10, "Phone number must be at least 10 digits")
    .max(15, "Phone number is too long")
    .regex(/^[0-9+\-\s()]+$/, "Please enter a valid phone number"),
  moveDate: z.date().optional(),
  inventory: z.array(inventoryItemSchema).optional(),
  message: z.string().max(1000, "Message is too long").optional(),
}).refine((data) => data.from !== data.to, {
  message: "Origin and destination cities must be different",
  path: ["to"],
})

export type InventoryItem = z.infer<typeof inventoryItemSchema>

export type QuoteFormData = z.infer<typeof quoteFormSchema>
